const initialPaymentReminder = {
    paymentreminders: [],
};

const paymentReducer = (paymentreminder = initialPaymentReminder, action) => {
    switch (action.type) {
        case 'GET_PAYMENT_REMINDER':
            return {
                ...paymentreminder, paymentreminders: action.payload.data
            };
        default:
            return paymentreminder;

    }
}
export default paymentReducer;